import React, { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
// import axios from "../../../axios/axios";
import axios from "../../../axios/axios";
// import RegistrationForm from "./RegistrationForm";
import PageHeader from "../../../components/PageHeader";
import PeopleOutlineRoundedIcon from "@mui/icons-material/PeopleOutlineRounded";
import AddIcon from "@mui/icons-material/Add";
// import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import DataGrid from "../../../components/useDataGrid";
import Popup from "../../../components/Popup";
import Controls from "../../../components/Controls";
import Checkbox from "@mui/material/Checkbox";
import ConfirmDialog from "../../../components/ConfirmDialog";
import Notification from "../../../components/Notification";
import { Stack } from "@mui/system";
import Grid from "@mui/material/Grid";
import { Typography, Box } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import SaveRoundedIcon from "@mui/icons-material/SaveRounded";

import { InputAdornment } from "@mui/material";
import { MyUseForm, MyForm } from "../../../components/useForm";

import * as GenServices from "../../../helper/GenServices";
import * as RegnServices from "../../../helper/RegnServices";
import { Toolbar } from "@mui/material";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";

import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";

// import OPDBillingForm from "../OPDBillingForm";
// import BillingDateUpdateForm from "./BillingDateUpdateForm";
import DirectBillPrint from "../DirectBillPrint";
import { useSelector, useDispatch } from "react-redux";
import { setAllOriginalFeeHeads, setAllFeeHeadsMasterList } from "../../../redux/actions";
import { useGlobalContext } from "../../../context/Context";
import DiscountForm from "./DiscountForm";


const initialValuesRegn = {
  // _id: "",
  mrNo: "",
  opdNo: "",
  name: "",
  soDo: "S/o.",
  fhName: "",
  gender: "",
  age: 0,
  pMobNo: "",
  // mobileNo: { pMobNo: "" },
  email: "",
  remarks: "",
  zeroBilling: false,
};

const initialValuesForSubmit = {
  _id: "",
  paidRs: "",
  billDetail: [{
    _id: "",
    feeHead: "",
    amount: 0,
    discAmt: 0,
    discBy: "",
    discDate: null,
    discIp: "",
    taxableAmt: 0,
    netAmt: 0,
    remarks: "",
  }],
};

export default function BillingDiscount() {
  const { staffUN, ip, isEditRight, isDeleteRight } = useGlobalContext();

  const dispatch = useDispatch();

  const [hid] = useState(2);

  const [loading, setLoading] = useState(false);

  const [zeroBilling, setZeroBilling] = useState(false);

  // const [originalReportData, setOriginalReportData] = useState([]);
  // const [reportData, setReportData] = useState([]);

  const [reportDataForRightTable, setreportDataForRightTable] = useState([]);

  // const [searchVal, setSearchVal] = useState("");

  // const hookAllFeeHeads = useSelector((state) => state.FeeHeadList_Reducer.feeHeadMain);

  // const [recordsOPD, setRecordsOPD] = useState([]);
  const [regnValues, setRegnValues] = useState(initialValuesRegn);
  // const [billListByMRNo, setreportDataForRightTable] = useState([]);
  const [mrNoValue, setMRNoValue] = useState("");
  // const [mainHeadType, setMainHeadType] = useState("");
  // const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = React.useState(false);
  // const [selectedValue, setSelectedValue] = React.useState({});
  const [notify, setNotify] = React.useState({ isOpen: false, message: "", type: "" });
  const [confirmDialog, setConfirmDialog] = React.useState({
    isOpen: false,
    isConfirm: null,
    title: "title",
    subtitle: "subtitle",
  });
  // const [patientTypeValue, setPatientTypeValue] = useState(GenServices.getPatientType());
  const [printForm, setPrintForm] = useState([]);
  const [isPrintDirect, setIsPrintDirect] = React.useState(false);
  // const [mrNoValueForReport, setMRNoValueForReport] = useState("");
  const [openPopupReceipt, setOpenPopupReceipt] = React.useState(false);
  // const [openPopupBillUpdate, setOpenPopupBillUpdate] = React.useState(false);

  // const [isDateUpdated, setIsDateUpdated] = React.useState(false);
  // const [dateForEdit, setDateForEdit] = React.useState({ _id: "", billDate: null }); //, isUpdated: false });

  const [errors, setErrors] = useState({});

  // const [totalPaidRsDetail, setTotalPaidRsDetail] = useState({
  //   paidRs: 0,
  //   // paymentMode: "Cash",
  //   // paymentDetail: "",
  // });

  // const [dataBottomTable, setDataBottomTable] = useState([]);
  // const [tempDataForSubmit, setTempDataForSubmit] = useState([]);
  const [finalDataForSubmit, setFinalDataForSubmit] = useState(initialValuesForSubmit);

  // const getAllOriginalFeeHeads = async () => {
  //   try {
  //     // const res = await axios.get("/fee/  headsub");
  //     const res = await axios.get("/fee/headlist"); //getAll <= here Get All MainHead + SubHead
  //     if (res) {
  //       dispatch(setAllOriginalFeeHeads(res.data));
  //     }
  //     // setLoading(false);
  //   } catch (error) {
  //     // setLoading(false);
  //     console.log("fee/headlist   getAllOriginalFeeHeads() res.data ===>  ", error);
  //     setNotify({ isOpen: true, message: error.message, type: "error" });
  //   }
  //   //setLoading(false);
  // };

  // useEffect(() => {
  //   getAllOriginalFeeHeads();
  //   // getMainHeads();
  // }, []);

  const handleSubmitDiscount = async (e) => {
    e.preventDefault();
    // console.log("finalDataForSubmit ===>", finalDataForSubmit);
    // console.log("totalPaidRsDetail ===>", totalPaidRsDetail);

    if (finalDataForSubmit.billDetail.length >= 1) {
      try {
        // console.log("axios Insert Start===>", Staff);
        setLoading(true);
        const res = await axios.patch(`/fee/opdbill/${finalDataForSubmit._id}`, finalDataForSubmit);
        // const res = await axios.patch(`/staff/updatepassword/${formData._id}`, formData);
        // console.log("axios Insert response===>", res);
        if (res) {
          bindData();
          //setTempDataForSubmit([]);
          setNotify({ isOpen: true, message: "Saved Successfully", type: "success" });
          setLoading(false);
        }

      } catch (error) {
        setLoading(false);
        console.error("error=====>", error);
        setNotify({ isOpen: true, message: error.message, type: "error" });
      }
    } else {
      setLoading(false);
      setNotify({
        isOpen: true,
        message: "Please add the Discount!",
        type: "error",
      });
    }
  };

  // useEffect(() => {
  //   // setFinalDataForSubmit(initialValuesForSubmit);
  //   let nestedArray = tempDataForSubmit.map((x) => {
  //     //"ref_fee_headMain.feeHeadMain",
  //     const {
  //       _id,
  //       discAmt,
  //       discGivenBy,
  //       discDate,
  //       discGivenIp,
  //       taxableAmt,
  //       netAmt,
  //       remarks,         
  //     } = { ...x };
  //     return {
  //       _id,
  //       discAmt,
  //       discGivenBy,
  //       discDate,
  //       discGivenIp,
  //       taxableAmt,
  //       netAmt,
  //       remarks,
  //     };
  //   }, {});

  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, ref_reg_opd: regnValues._id }));
  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, mrNo: regnValues.mrNo }));
  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, opdNo: regnValues.opdNo }));
  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, feeHeadType: mainHeadType}));
  //   // setFinalDataForSubmit((preValues) => {
  //   //   return { ...preValues, paidRs: totalPaidRsDetail.find((element) => element.text == "paidRs").paidRs };
  //   // });

  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, paidRs: totalPaidRsDetail.paidRs }));
  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, paymentMode: totalPaidRsDetail.paymentMode }));
  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, paymentDetail: totalPaidRsDetail.paymentDetail }));

  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, staffUN: staffUN }));
  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue, ip: ip }));

  //  // setFinalDataForSubmit((prevValue) => ({ ...prevValue, billDetail: nestedArray }));

  //   // setFinalDataForSubmit((prevValue) => ({ ...prevValue,  billDetail: tempDataForSubmit.map((x) => {
  //   //   const { feeHead, rate, qty, amount, discPer, discAmt, taxableAmt, cgstRate, cgstAmt, sgstRate, sgstAmt, igstRate, igstAmt, netAmt, remarks, } = { ...x };
  //   //   const { feeHeadMain } = { ...x.ref_fee_headMain };
  //   //   return { feeHeadMain, feeHead, rate, qty, amount, discPer, discAmt, taxableAmt, cgstRate, cgstAmt, sgstRate, sgstAmt, igstRate, igstAmt, netAmt, remarks, };
  //   // })}));
  // }, [tempDataForSubmit, totalPaidRsDetail]);

  // useEffect(() => {
  //   console.log("finalDataForSubmit======>", finalDataForSubmit);
  // }, [finalDataForSubmit]);

  // const { formData, setFormData, errors, setErrors, handleChange } = MyUseForm(initialValuesOpd, true, validateForm);

  // const getOPDBillingRecord = async () => {
  //   //setLoading(true);
  //   // validate(initialValues);
  //   try {      
  //     const res = await axios.get(`/fee/opdbill/report/?hid=${hid}&startdate=${dayjs()}&enddate=${dayjs()}`);
  //     if (res) {        
  //       setReportData(res.data);
  //     }
  //     // setLoading(false);
  //   } catch (error) {
  //     // setLoading(false);
  //     console.error("Error ===>", error);
  //     setNotify({ isOpen: true, message: error.message, type: "error" });
  //   }
  //   //setLoading(false);
  // };

  // useEffect(() => {
  //   getOPDBillingRecord();
  // }, []);

  const bindData = () => {
    // resetForm();
    // setRecordForEdit(null);
    setOpenPopup(false);
    //getOPDBillingRecord();
    getBillListByMRNo();
  };

  // const handleByRightTable = (curItem) => {
  //   setRegnValues({ ...regnValues, opdNo: curItem.opdNo });
  // };

  const resetForm = () => {
    // setFormData(initialValuesOpd);
    setMRNoValue("");
    setRegnValues(initialValuesRegn);
    // setRecordForEdit(null);
    // setErrors({});
    setNotify({ isOpen: false, message: "", type: "" });
    setLoading(false);
    setreportDataForRightTable([]);
    // setMRNoValueForReport("");
  };

  const getBillListByMRNo = async () => {
    //setLoading(true);
    // validate(initialValues);
    try {
      if (mrNoValue) {
        // const res = await axios.get(`/fee/opdbill/opdvisitlist/${mrNoValue}`);
        const res = await axios.get(`/fee/opdbill/getallopdbillbymrno/?hid=${hid}&mrNo=${mrNoValue}`);
        //  console.log("getBillListByMRNo  ===>", res);

        if (res) {
          setreportDataForRightTable(res.data);
          // console.log("res.data ===>", res.data)
        }
      }
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      console.error("Error ===>", error);
      setNotify({ isOpen: true, message: error.message, type: "error" });
    }
    //setLoading(false);
  };

  const getDataByMRNo = async () => {
    try {
      // if (recordForEdit === null) {
      if (mrNoValue) {
        const res = await axios.get(`/fee/opdbill/opddatabymrno/?hid=${hid}&mrNo=${mrNoValue}`);
        if (res.data) {
          // console.log("AAAAAAA getDataByMRNo  ========> ", res.data);
          // let data = res.data;
          // console.log("getDataByMRNo  ========> ", data);
          setRegnValues(res.data);
          setZeroBilling(res.data.zeroBilling);

          await getBillListByMRNo();

          // const rrr = res.data.map((item)=>{
          //   console.log("item  ========> ", item);
          // })
          // console.log("getDataByMRNo rrr  ========> ", rrr);
          // setFormData((preValues) => ({ ...preValues, ref_reg_patient: res.data[0]._id }));
          // setFormData((preValues) => {
          //   return { ...preValues, mrNo: res.data[0].mrNo };
          // });
        } else {
          setNotify({ isOpen: true, message: "Data not found!", type: "error" });
        }
      } else {
        setNotify({ isOpen: true, message: "Please enter the MRNo!", type: "error" });
      }
      // } else {
      //   setNotify({ isOpen: true, message: "Please reset the form!", type: "error" });
      // }
    } catch (error) {
      console.error("getDataByMRNo Error ===>", error);
      setNotify({ isOpen: true, message: error.message, type: "error" });
    }
  };

  const handleChangeMRNo = (e) => {
    // if (recordForEdit === null) {
    setErrors({});
    setMRNoValue(e.target.value);
    setRegnValues(initialValuesRegn);
    setLoading(false);
    setreportDataForRightTable([]);
  };

  const handlePrintBill = (item) => {
    setIsPrintDirect(true);
    setPrintForm({ ...item });
    setOpenPopupReceipt(true);
  };

  const openPopupForAddDiscount = (BillData) => {
    if (!regnValues.mrNo || !regnValues.opdNo || !regnValues.name) {
      setNotify({ isOpen: true, message: "Please enter the Patient Detail....", type: "error" });
      return;
    }
    // setRecordForEdit(null);
    setOpenPopup(true);
    setNotify({ isOpen: false, message: "", type: "" });
    // setTotalPaidRsDetail({ paidRs: 0, paymentMode: "Cash", paymentDetail: "" });

    setFinalDataForSubmit(BillData);

    //const filteredData = getDiscountRelevantData(BillData);
    //setFinalDataForSubmit(filteredData);
  };

  const getDiscountRelevantData = (fullData) => {
    return {
      _id: fullData._id || "",
      paidRs: fullData.paidRs || "",
      billDetail: Array.isArray(fullData.billDetail)
        ? fullData.billDetail.map((item) => ({
          _id: item._id || "",
          feeHead: item.feeHead || "",
          amount: item.amount || 0,
          discAmt: item.discAmt || 0,
          discBy: item.discBy || "",
          discDate: item.discDate || null,
          discIp: item.discIp || "",
          taxableAmt: item.taxableAmt || 0,
          netAmt: item.netAmt || 0,
          remarks: item.remarks || "",
        }))
        : [],
    };
  };


  const columnsForRightTopTable = [
    {
      field: "actions",
      headerName: "Print",
      width: 50,
      sortable: false,
      renderCell: (curItem) => {
        return (
          <>
            <Stack direction="row" spacing={1}>
              <Controls.ActionButton
                color="primary"
                title="Print OPD-Bill Cum Receipt"
                onClick={() => handlePrintBill(curItem.row)}
              >
                <PrintIcon />
              </Controls.ActionButton>
            </Stack>
          </>
        );
      },
    },
    { field: "mrNo", headerName: "MRNo", width: 80 },
    {
      field: "billDate",
      headerName: "Bill-No/Date",
      width: 120,
      // valueGetter: (item) => dayjs(item.row.billDate).format("DD/MMM/YYYY hh:mm a"),
      renderCell: (item) => (
        <div>
          <Typography>
            <Controls.Button
              title="Add Nested Test"
              text={item.row.billNo}
              onClick={() => openPopupForAddDiscount(item.row)}
              variant="outlined"
            />
          </Typography>
          <Typography color="textSecondary" sx={{ fontSize: 13 }}>
            {dayjs(item.row.billDate).format("DD/MM/YYYY")}
          </Typography>
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name/FName",
      width: 150,
      // valueGetter: (item) => item.row.name,
      renderCell: (item) => (
        <div>
          <Typography>{item.row.name}</Typography>
          <Typography color="textSecondary" sx={{ fontSize: 12 }}>
            {item.row.fhName}
          </Typography>
        </div>
      ),
    },
    {
      field: "paidRs",
      headerName: "PaidRs",
      width: 80,
      // valueGetter: (item) => item.row.name,
      renderCell: (item) => (
        <div>
          <Typography>{item.row.paidRs}</Typography>
          <Typography color="textSecondary">{item.row.paymentMode}</Typography>
        </div>
      ),
    },
    { field: "feeHeadList", headerName: "Fee-Head-List", width: 350 },
  ];

  return (
    <>
      <PageHeader
        title="Billing Discount"
        subTitle=""
        icon={<PeopleOutlineRoundedIcon fontSize="large" color="primary" />}
      />

      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            {/* <Typography variant="h6" color="inherit" noWrap sx={{ pb: 1 }}>
              OPD/IPD Bill/Receipt Entry
            </Typography> */}

            <Grid container spacing={2}>
              {/* mrNo */}
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <Controls.Input
                  label="MRNo"
                  name="mrNo"
                  type="number"
                  value={mrNoValue}
                  onChange={handleChangeMRNo}
                  title="press tab key for get record"
                  onKeyDown={(e) => (e.key === "Tab" ? getDataByMRNo() : "")}
                  // error={errors.mrNo}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setMRNoValue("");
                            setreportDataForRightTable([]);
                            setRegnValues(initialValuesRegn);
                          }}
                          color="primary"
                          sx={{ p: "10px" }}
                          aria-label="directions"
                        >
                          <ClearIcon />
                        </IconButton>
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <IconButton onClick={getDataByMRNo} color="primary" sx={{ p: "10px" }} aria-label="directions">
                          <DirectionsIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}

                // InputProps={{
                //   endAdornment: (
                //     <InputAdornment position="end">
                //       <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                //       <IconButton onClick={getDataByMRNo} color="primary" sx={{ p: "10px" }} aria-label="directions">
                //         <DirectionsIcon />
                //       </IconButton>
                //     </InputAdornment>
                //   ),
                // }}
                />
              </Grid>
              {/* opdNo */}
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <Controls.Input
                  label="OPDNo"
                  name="opdNo"
                  value={regnValues.opdNo}
                  // onChange={handleChange}
                  error={errors.opdNo}
                  // style={{background: "rgb(232, 241, 250)"}}
                  style={{ background: "#e9e9e9" }}
                />
              </Grid>
              {/* </Grid>
            
            <Grid container spacing={2}> */}

              {/* <Box width="100%" /> */}
              {/* Name */}
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Controls.Input
                  label="Full Name"
                  name="name"
                  value={regnValues.name}
                  // onChange={handleChange}
                  error={errors.name}
                  // style={{background: "rgb(232, 241, 250)"}}
                  style={{ background: "#e9e9e9" }}
                />
              </Grid>
              {/* Father/MotherName */}
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Controls.Input
                  label="Father/Husband Name"
                  name="fhName"
                  value={regnValues.fhName}
                  // onChange={handleChange}
                  error={errors.fhName}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{regnValues.soDo}</InputAdornment>,
                  }}
                  style={{ background: "#e9e9e9" }}
                />
              </Grid>
              {/* Gender/Age */}
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <Controls.Input
                  label="Gender/Age"
                  name="gender"
                  value={regnValues.gender + " / " + regnValues.age}
                  // onChange={handleChange}
                  // options={GenServices.getGender()}
                  // error={errors.gender}
                  style={{ background: "#e9e9e9" }}
                />
              </Grid>
              {/* Email */}
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <Controls.Input
                  label="Email"
                  name="email"
                  value={regnValues.email}
                  // onChange={handleChange} error={errors.email}
                  style={{ background: "#e9e9e9" }}
                />
              </Grid>
              {/* mobileNo.pMobNo */}
              <Grid item xs={6} sm={6} md={3} lg={3}>
                <Controls.Input
                  label="Mobile Number"
                  name="pMobNo"
                  value={regnValues.pMobNo}
                  // onChange={handleChange}
                  // error={errors.pMobNo}
                  style={{ background: "#e9e9e9" }}
                />
              </Grid>

              {/* zeroBilling */}
              <Grid item xs={6} sm={6} md={3} lg={3}>
                <Controls.Checkbox
                  label="Zero-Billing"
                  name="zeroBilling"
                  value={regnValues.zeroBilling}
                // onChange={handleChange}
                // error={errors.zeroBilling}
                />
              </Grid>

              {/* remarks */}
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Controls.Input
                  label="Remarks"
                  name="remarks"
                  value={regnValues.remarks}
                  // onChange={handleChange}
                  // error={errors.remarks}
                  style={{ background: "#e9e9e9" }}
                />
              </Grid>

              <Divider sx={{ width: "100%", height: 10, m: 0.5 }} orientation="horizontal" />

              {/* Button */}
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Box m={1} display="flex">
                  <span>
                    <Controls.Button
                      text="Reset"
                      onClick={resetForm}
                      // variant="outlined"
                      //variant="outlined"
                      startIcon={<RestartAltIcon />}
                    // color="default"
                    />
                  </span> 
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <DataGrid
              // heading="Patient Wise Bill List" in the Right-Top Corner
              columns={columnsForRightTopTable}
              rows={reportDataForRightTable}
              showToolbar={false}
              margin="dense"
            />
          </Grid>
        </Grid>
      </Box>

      <Box>
        {/* maxWidth="el" */}
        <Popup title="Add Discount" openPopup={openPopup} setOpenPopup={setOpenPopup}>
          <DiscountForm
            finalDataForSubmit={finalDataForSubmit}
            setFinalDataForSubmit={setFinalDataForSubmit}
            handleSubmitDiscount={handleSubmitDiscount}            
            loading={loading}
          // zeroBilling={zeroBilling}
          />
        </Popup>
      </Box>

      {/* <Box>
        <DataGrid
          // heading="This is Bottom Table showing the Billing Record of Today"
          columns={columnsBillsReportTable}
          rows={reportData}
          pageSize={40}
          boxHeight={680}
          // showToolbar={true}
        />
      </Box> */}
      <br></br>

      <Popup title="" openPopup={openPopupReceipt} setOpenPopup={setOpenPopupReceipt} isCloseOutside={true}>
        <DirectBillPrint
          // billHeading="OPD Bill - Cum - Receipt"
          billHeading="Receipt"
          // feeHead="OPD Registration Charges"
          {...printForm}
          // isPrintDirect={isPrintDirect}
          setIsPrintDirect={setIsPrintDirect}
        />
      </Popup>

      <Notification notify={notify} setNotify={setNotify} />

      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      {/* <div>Note: Only admin can change bill date and click on blue button to change date.</div> */}
    </>
  );
}
